import React from 'react';
import { Link } from 'react-router-dom';
import './PlanSite.css';
import SectionTitle from '../SectionTitle/SectionTitle';

const PlanSite = () => {
  return (
    <div className="PlanSite">
      <SectionTitle classname="PlanSite__title">
        Plan du
        <strong className="SectionTitle__item--bold">&nbsp;site</strong>
      </SectionTitle>
      <ul className="PlanSite__list">
        <li className="PlanSite__link">
          <Link to="/">Accueil</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/notre-reseau">Notre réseau</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-partenaires">Nos partenaires</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-pharmacies">Nos pharmacies</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nous-rejoindre">Nous rejoindre</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/cgu">CGU</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/plan-du-site">Plan du Site</Link>
        </li>
      </ul>
    </div>
  );
};

export default PlanSite;
